import r from "./_mapCacheClear.js";
import m from "./_mapCacheDelete.js";
import h from "./_mapCacheGet.js";
import c from "./_mapCacheHas.js";
import C from "./_mapCacheSet.js";
var l = r, i = m, f = h, s = c, _ = C;
function e(a) {
  var t = -1, o = a == null ? 0 : a.length;
  for (this.clear(); ++t < o; ) {
    var p = a[t];
    this.set(p[0], p[1]);
  }
}
e.prototype.clear = l;
e.prototype.delete = i;
e.prototype.get = f;
e.prototype.has = s;
e.prototype.set = _;
var u = e;
export {
  u as default
};
//# sourceMappingURL=_MapCache.js.map
